<div class="flex items-center justify-center h-full">
  <ng-container *ngIf="!info?.picture">
    <div *ngIf="isHundredPercentSize" class="flex flex-auto justify-center" [style.backgroundColor]="info.initialsColor || '#d0d0d0'">
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </div>
    <ng-container *ngIf="!isHundredPercentSize">
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </ng-container>
    <ng-template #content>
      <div
        class="flex flex-column rounded-full items-center justify-center"
        [class.border-2]="!isHundredPercentSize && info?.size !== UserAvatarSize.CustomLayout"
        [ngClass]="'border-' + borderColor"
        [style.fontSize.px]="fontSize"
        [style.height.px]="size" 
        [style.width.px]="size"
        [style.min-height.px]="size" 
        [style.min-width.px]="size"
        [style.backgroundColor]="info?.initialsColor || '#d0d0d0'"
      >
        <div *ngIf="!info?.type || info?.type == 1"  class="text-white whitespace-nowrap" [style.lineHeight.px]="fontSize" [style.fontSize.px]="fontSize">
          {{initials}}
        </div>
        <mat-icon *ngIf="info?.type == 2" svgIcon="mat_solid:place" class="teams-areas-icon text-white"></mat-icon>
        <mat-icon *ngIf="info?.type == 3" svgIcon="mat_solid:groups" class="teams-areas-icon text-white"></mat-icon>
      </div>
    </ng-template>
  </ng-container>
  <ng-container *ngIf="info?.picture">
    <svc-img 
      [src]="(highDefinition && info?.pictureHQ) ? info?.pictureHQ : info?.picture" 
      [customClass]="(!isHundredPercentSize ? 'rounded-full' : '') + (' border-' + borderColor)"
      [borderWidth]="(!isHundredPercentSize && info?.size !== UserAvatarSize.CustomLayout) ? 2 : 0"
      [style.height.%]="isHundredPercentSize ? 100 : null"
      [style.width.%]="isHundredPercentSize ? 100 : null"
      [height]="isHundredPercentSize ? '100%' : (size + 'px')"
      [width]="isHundredPercentSize ? '100%' : (size + 'px')"
      [minHeight]="isHundredPercentSize ? '100%' : (size + 'px')"
      [minWidth]="isHundredPercentSize ? '100%' : (size + 'px')"
      (onError)="onImgLoadError()"
    ></svc-img>
  </ng-container>
</div>
<ng-content></ng-content>
